module.exports = __webpack_public_path__ + "files/1dca7cc81372f98b3f4c5cc0d5a785d2.png";